import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ColorEvent } from 'ngx-color';
import { ColorChromeModule } from 'ngx-color/chrome';
import { ContextMenu } from '../../ui/context-menu/context-menu';
import { ContextMenuTriggerDirective } from '../../ui/context-menu/context-menu-trigger.directive';

@Component({
  selector: 'andor-color-picker',
  standalone: true,
  imports: [CommonModule, ColorChromeModule, ContextMenu, ContextMenuTriggerDirective],
  templateUrl: './color-picker.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './color-picker.scss',
})
export class ColorPicker implements OnInit {
  @Output() changedColor = new EventEmitter<string>();
  @Input() initialColor = '';
  @Input() toolTip = '';
  @Input() label = 'Label';
  currentColor = '';

  ngOnInit(): void {
    this.currentColor = `background: rgb(${this.initialColor})`;
  }
  onColorChange($event: ColorEvent) {
    const color = `${$event.color.rgb.r}, ${$event.color.rgb.g}, ${$event.color.rgb.b}`;
    this.changedColor.emit(color);
    this.currentColor = `background: rgb(${$event.color.rgb.r}, ${$event.color.rgb.g}, ${$event.color.rgb.b})`;
  }

  get state() {
    const [r, g, b] = this.initialColor.split(',').map((elem) => parseInt(elem.trim()));
    return { r, g, b, a: 0 };
  }
}
